import AddEditRevenueRow from "./AddEditRevenueRow/AddEditRevenueRow";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { RevenueExpenseRef } from "../../../../models/revenue-expense/revenue-expense-ref";
import { TransactionDTO } from "../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";
import { Amounts, HeaderRow, MainBlock, StyledTableCell, TableBodyRow } from "../styles";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const Revenues = ({
  transaction: { revenues, legalEntity, currency, transactionDate },
  readOnly = false,
  handleChange,
}: Props) => {
  const handleChangeRevenue = (value: RevenueExpenseRef, idx: number): void => {
    idx < 0
      ? handleChange && handleChange("revenues", [...revenues, value])
      : handleChange && handleChange("revenues", [...revenues.slice(0, idx), value, ...revenues.slice(idx + 1)]);
  };

  const handleRemoveRevenue = (idx: number): void =>
    handleChange && handleChange("revenues", [...revenues.slice(0, idx), ...revenues.slice(idx + 1)]);

  return (
    <>
      <MainBlock>
        <HeaderRow container>
          <StyledTableCell>Revenue type</StyledTableCell>
          <StyledTableCell>Project</StyledTableCell>
          <StyledTableCell>Employee</StyledTableCell>

          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Amount
          </StyledTableCell>
          <StyledTableCell flex={1}>Exchange rate</StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Booked amount
          </StyledTableCell>
          {!readOnly && (
            <StyledTableCell width={100}>
              <AddEditRevenueRow
                handleChangeRevenue={(value) => handleChangeRevenue(value, -1)}
                legalEntity={legalEntity}
                currency={currency}
                date={CustomDate.ToDate(transactionDate) as Date}
              />
            </StyledTableCell>
          )}
        </HeaderRow>

        {revenues?.map((revenue, idx) => {
          return (
            <TableBodyRow
              container
              key={revenue.id}
            >
              <StyledTableCell>{revenue?.revenueExpenseType?.name ?? ""}</StyledTableCell>
              <StyledTableCell>{revenue?.project?.name ?? ""}</StyledTableCell>
              <StyledTableCell>{revenue?.employee?.name ?? ""}</StyledTableCell>

              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+revenue?.amount).toLocaleCustom()} ${revenue?.currency?.code ?? ""}`}
              >
                <Amounts>{`${(+revenue?.amount).toLocaleCustom()} ${revenue?.currency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              <StyledTableCell flex={1}>{revenue?.exchangeRate}</StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+revenue?.bookedAmount).toLocaleCustom()} ${revenue?.bookedCurrency?.code ?? ""}`}
              >
                <Amounts>{`${(+revenue?.bookedAmount).toLocaleCustom()} ${
                  revenue?.bookedCurrency?.code ?? ""
                }`}</Amounts>
              </StyledTableCell>
              {!readOnly && (
                <StyledTableCell width={100}>
                  <AddEditRevenueRow
                    handleChangeRevenue={(value) => handleChangeRevenue(value, idx)}
                    legalEntity={legalEntity}
                    item={revenue}
                    date={CustomDate.ToDate(transactionDate) as Date}
                  />
                  <ConfirmationRemoveItemDialog
                    index={idx}
                    handleRemove={handleRemoveRevenue}
                  />
                </StyledTableCell>
              )}
            </TableBodyRow>
          );
        })}
      </MainBlock>
    </>
  );
};

export default Revenues;
